import React, { useEffect, useState } from "react";
import View from 'src/components/view';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Element from 'src/components/element';
import utils from "src/components/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle, faCheck, faWindowClose, faTimes } from "@fortawesome/free-solid-svg-icons";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import { height } from "@amcharts/amcharts4/.internal/core/utils/Utils";
import { Translate } from "@material-ui/icons";


function ClonagemCliente() {
  let [view, setView] = useState({});
  let [crud, setCrud] = useState({ data: {}, changed: {} });
  let [ready, setReady] = useState(false);
  let [index, setIndex] = useState(0);
  let [showDialogSelecaoCliente, setShowDialogSelecaoCliente] = useState(false);
  let [showDialogClientesDestino, setShowDialogClientesDestino] = useState(false);
  
  let [clienteCopiar, setClienteCopiar] = useState(null);
  let [filialDestino, setFilialDestino] = useState(null);

  let [isRedeProjetada, setIsRedeProjetada] = useState(false);
  
  const user = utils.getUser();
  
  let [idClienteClonar, setIdClienteClonar] = useState(null);
  let [idFilialDestino, setIdFilialDestino] = useState(null);
  let [listaClientesEncontrados, setListaClientesEncontrados] = useState([]);
  let [clientePosicaoSelecionada, setClientePosicaoSelecionada] = useState(null);

  let urlParts = window.location.pathname.substring(1).split('/');

  let [listaRedeProjetadaClonagem, setListaRedeProjetadaClonagem] = useState([]);

  let [loading,setLoading] = useState(false);

  const getChaveCache = function() {
    return 'USR_'+utils.getUser().id+'_clonagem_cliente_projecao';
  };

  const setCacheProjecaoRede = function() {
    let objCache = {idClienteClonar: idClienteClonar, idFilialDestino: idFilialDestino, listaRedeProjetadaClonagem: listaRedeProjetadaClonagem};
    window.localStorage.setItem(getChaveCache(), JSON.stringify(objCache));
  };

  const reloadProjecaoRede = function() {
    let jsonRedeProjetada = window.localStorage.getItem(getChaveCache());
    if (jsonRedeProjetada) {
      let objCache = JSON.parse(jsonRedeProjetada);;
      idClienteClonar = objCache.idClienteClonar;
      if (idClienteClonar && idClienteClonar > 1) {
        setIdClienteClonar(idClienteClonar);
        loadClienteClonar(idClienteClonar, false);
      }
      idFilialDestino = objCache.idFilialDestino;
      if (idFilialDestino && idFilialDestino > 1) {
        setIdFilialDestino(idFilialDestino);
        loadFilialDestino(idFilialDestino, false);
      }
      listaRedeProjetadaClonagem = objCache.listaRedeProjetadaClonagem;
      setListaRedeProjetadaClonagem(listaRedeProjetadaClonagem);
    }
  };

  const clearCacheProjecaoRede = function() {
    window.localStorage.removeItem(getChaveCache());
  };

  view.loadingEnd = function () {
    loading = false;
    setLoading(false);
  };

  view.loadingStart = function () {
    loading = true;
    setLoading(true);
  };

  window.view = view;

  crud.onChangeCliente = function(el, args) {
    clienteCopiar = args.cliente_copiar;
    setClienteCopiar(clienteCopiar);
    if (clienteCopiar && clienteCopiar.id > 0) {
      changeIsRedeProjetada();
    }
  };

  crud.onChangeFilial = function(el, args) {
    filialDestino = args.filial_destino;
    setFilialDestino(filialDestino);
    if (filialDestino && filialDestino.id > 0) {
      idFilialDestino = filialDestino.id;
      setIdFilialDestino(idFilialDestino);
      changeIsRedeProjetada();
    } else {
      idFilialDestino = null;
      setIdFilialDestino(idFilialDestino);
    }
  };

  crud.limpaTela = function() {
    resetVars();
    clearCacheProjecaoRede();
  };

  const resetVars = function() {
    clienteCopiar = null;
    filialDestino = null;
    listaRedeProjetadaClonagem = [];
    setClienteCopiar(clienteCopiar);
    crud.elements.cliente_copiar.setValue(clienteCopiar);
    setFilialDestino(filialDestino);
    crud.elements.filial_destino.setValue(filialDestino);
    setListaRedeProjetadaClonagem(listaRedeProjetadaClonagem);
    changeIsRedeProjetada();
  };

  crud.requestProjecaoRede = function() {
    if (clienteCopiar && filialDestino) {
      view.loadingStart();
      const request_projecao_rede = {};
    
      request_projecao_rede.crud = crud;
      request_projecao_rede.validate = false;
      request_projecao_rede.changed = crud.data;
      request_projecao_rede.element = {};

      request_projecao_rede.cfg = {
        url: 'copia/cliente/projecao_rede?id_cliente='+ clienteCopiar.id+'&id_filial_destino='+filialDestino.id,
        method: 'GET'
      };
      request_projecao_rede.complete = (res) => {
        if (res.data && res.data.length > 0) {
          listaRedeProjetadaClonagem = res.data;
          setListaRedeProjetadaClonagem(listaRedeProjetadaClonagem);
          changeIsRedeProjetada();
        }
        view.loadingEnd();
      };
      utils.call(request_projecao_rede);
    }
  };

  const changeIsRedeProjetada = function() {
    isRedeProjetada = clienteCopiar != null &&
          filialDestino != null &&
          (
            listaRedeProjetadaClonagem && 
            listaRedeProjetadaClonagem != null && 
            listaRedeProjetadaClonagem.length > 0 &&
            !listaRedeProjetadaClonagem.some(
              li => li.isVariosClientesDestino === true && li.isNovoCadastro === false
            )
          );
    setIsRedeProjetada(isRedeProjetada);
    return isRedeProjetada;
  };

  const loadClienteClonar = function(idClienteClonar, requestProjecaoRede) {
    if (idClienteClonar && idClienteClonar > 0) {
      utils.execute(crud, 'Cliente/' + idClienteClonar, null, function (res) {
        if (res.data && res.data.id > 0) {
          clienteCopiar = res.data;
          setClienteCopiar(clienteCopiar);
          crud.elements.cliente_copiar.setValue(clienteCopiar);
          if (clienteCopiar && clienteCopiar.id > 0 && filialDestino && filialDestino.id > 0 && requestProjecaoRede) {
            crud.requestProjecaoRede();
          }
        }
      }, true);
    }
  };

  const loadFilialDestino = function (idFilialDestino, requestProjecaoRede) {
    if (idFilialDestino && idFilialDestino > 0) {
      utils.execute(crud, 'Filial/' + idFilialDestino, null, function (res) {
        if (res.data && res.data.id > 0) {
          filialDestino = res.data;
          setFilialDestino(filialDestino);
          crud.elements.filial_destino.setValue(filialDestino);
          if (clienteCopiar && clienteCopiar.id > 0 && filialDestino && filialDestino.id > 0 && requestProjecaoRede) {
            crud.requestProjecaoRede();
          }
        }
      }, true);
    }
  };

  
  useEffect(() => {
    if (!ready) {
      setReady(true);

      if (urlParts.length > 1) {
        idClienteClonar = urlParts[1];
        if (idClienteClonar && idClienteClonar > 1) {
          setIdClienteClonar(idClienteClonar);
          loadClienteClonar(idClienteClonar, true);
        }
        try {
          idFilialDestino = urlParts[2];
          if (idFilialDestino && idFilialDestino > 1) {
            setIdFilialDestino(idFilialDestino);
            loadFilialDestino(idFilialDestino, true);
          }
        } catch (e) {}
      } else {
        reloadProjecaoRede();
      }
    }
  });
  
  
  const confirmarClonagemRede = function () {
    if (!isRedeProjetada) {
      let actions = [];
      actions.push({ label: utils.lng('confirmar', 'Confirmar'), action: () => {} });
      if (window.dialog) {
        window.dialog.alert(
          utils.lng('faltam_informacoes_efetivar_clonagem', 'Faltam informações para efetivar a clonagem da rede, Verifique!'), null, actions
        );
      }
    } else {
      let msgValidacao = validaListaClientes(listaRedeProjetadaClonagem);
      if (msgValidacao === '') {
        validaDocumentoClientePrincipal(listaRedeProjetadaClonagem);
      } else {
        let actions = [];
        actions.push({ label: utils.lng('confirmar', 'Confirmar'), action: () => {} });
        if (window.dialog) {
          window.dialog.alert(msgValidacao, null, actions);
        }
      }
    }
  };

  const validaListaClientes = function(listaClientes) {
    let msgValidacao = validaPresencaFilialDestino(listaClientes);
    // if (!msgValidacao || msgValidacao === '') {
    //   msgValidacao = validaDocumentos(listaClientes);
    // }
    return msgValidacao;
  };

  const validaPresencaFilialDestino = function(listaClientes) {
    let hasAlgumClienteNovo = false;
    for (let i=0; i<listaClientes.length; i++) {
      let cliente = listaClientes[i];
      if (cliente) {
        hasAlgumClienteNovo = cliente.isNovoCadastro === true;
        if (hasAlgumClienteNovo === true) {
          break;
        }
      }
    }
    let msg = hasAlgumClienteNovo ? '' : utils.lng(
      'todos_clientes_existem_filial_destino', 
      'Todos os Clientes da rede projetada já existem na Filial de Destino. Verifique!'
    );
    return msg;
  };

  const validaDocumentoClientePrincipal = function(listaClientes) {
    let clientePrincipal = listaClientes.find(clienteLista => clienteLista.ordemGeracional === 0);
    if (clientePrincipal) {
      let url = 'cliente/valida_documento/'+clientePrincipal.tipoPessoa+'/'+clientePrincipal.documentoNovoCadastro+'/'+filialDestino.id;
                //'?documento='+clientePrincipal.documentoNovoCadastro+
                //'&tipo_pessoa='+clientePrincipal.tipoPessoa+
                //'&id_filial='+filialDestino.id;
      utils.execute(crud, url, null, function (res) {
        if (res.data && res.data.documento_valido === true) {
          let actions = [];
          actions.push({ label: utils.lng('cancelar', 'Cancelar'), action: () => {} });
          actions.push({ label: utils.lng('confirmar', 'Confirmar'), action: () => {gravaRedeClonada()} });
          if (window.dialog) {
            window.dialog.alert(utils.lng('confirm_clonagem_rede','Deseja realmente clonar os cadastros selecionados?'), null, actions);
          }
        }
      }, true);
    } else {
      let actions = [];
      actions.push({ label: utils.lng('confirmar', 'Confirmar'), action: () => {} });
      if (window.dialog) {
        window.dialog.alert(utils.lng('falha_validar_documento_cliente_principal','Falha ao tentar validar o documento do cliente principal. Verique!'), null, actions);
      }
    }
  };

  // const validaDocumentos = function(listaClientes) {
  //   let todosDoctosPreenchidos = false;
  //   for (let i=0; i<listaClientes.length; i++) {
  //     let cliente = listaClientes[i];
  //     if (cliente) {
  //       todosDoctosPreenchidos = cliente.documentoNovoCadastro != '' && (cliente.documentoNovoCadastro && cliente.documentoNovoCadastro.length > 1);
  //       if (todosDoctosPreenchidos === false) {
  //         break;
  //       }
  //     }
  //   }
  //   return todosDoctosPreenchidos ? '' : utils.lng('todos_doctos_devem_ser_preenchidos', 'Todos os Documentos devem ser Preenchidos. Verifique!');
  // };

  const gravaRedeClonada = function() {
    const request_post_rede = {};
    view.loadingStart();
    request_post_rede.crud = crud;
    request_post_rede.validate = false;
    request_post_rede.changed = crud.data;
    request_post_rede.element = {};
    request_post_rede.body = {"rede":listaRedeProjetadaClonagem};
    request_post_rede.cfg = {
      url: 'copia/cliente/rede_completa?id_cliente='+ clienteCopiar.id+'&id_filial_destino='+filialDestino.id,
      method: 'POST'
    };
    request_post_rede.complete = (res) => {
      view.loadingEnd();

      clearCacheProjecaoRede();
      
      if (res.data && res.data.length > 0) {
        window.location.href = "/clonagem_cliente/"+clienteCopiar.id+'/'+filialDestino.id;
      }
    };
    utils.call(request_post_rede);
  };

  //

  const switchDialogSelecaoClientes = function() {
    showDialogSelecaoCliente = !showDialogSelecaoCliente;
    setShowDialogSelecaoCliente(showDialogSelecaoCliente);
  };

  const switchDialogClientesDestino = function() {
    showDialogClientesDestino = !showDialogClientesDestino;
    setShowDialogClientesDestino(showDialogClientesDestino);
  };

  let [indiceListaClienteTrocar, setIndiceListaClienteTrocar] = useState(null);
  const abreSelecaoCliente = function(index, obj) {
    indiceListaClienteTrocar = index;
    setIndiceListaClienteTrocar(indiceListaClienteTrocar);
    switchDialogSelecaoClientes();
  };

  crud.selecionaCliente = function(el, item) {
    let clienteEscolhido = item ? item.data : null;
    if (clienteEscolhido && clienteEscolhido.id > 0) {
      let statusInicial = clientePosicaoSelecionada.statusInicial ? clientePosicaoSelecionada.statusInicial : "gerar_novo_cliente";
      let bkpClienteOriginal = clienteEscolhido.bkpClienteOriginal;
      if (!bkpClienteOriginal) {
        bkpClienteOriginal = utils.copyObject(clientePosicaoSelecionada);
      }
      utils.prompt(
        {
          prompt: utils.lng(
            'deseja_selecionar_este_cliente_para_clonagem',
            'Deseja selecionar este Cliente para clonagem?',
          ),
        },
        function () {
          let url = 'copia/cliente/dto_cliente_projecao_rede?id_cliente=' + clienteEscolhido.id + 
                '&id_filial_destino=' + idFilialDestino + 
                '&indice_ordem_geracional='+indiceListaClienteTrocar
          utils.execute(crud, url, null, function (res) {
            if (res.data && res.data.id > 0) {
              clienteEscolhido = res.data;
              clienteEscolhido.statusInicial = statusInicial;
              if (bkpClienteOriginal && bkpClienteOriginal.lista_clientes_destino) {
                clienteEscolhido.cliente_origem = bkpClienteOriginal.cliente_origem;
                clienteEscolhido.lista_clientes_destino = bkpClienteOriginal.lista_clientes_destino;
              }
              if (bkpClienteOriginal) {
                clienteEscolhido.bkpClienteOriginal = bkpClienteOriginal;
              }
              let isClienteNaLista = listaRedeProjetadaClonagem.some(obj => obj.id === clienteEscolhido.id);
              if (isClienteNaLista) {
                let actions = [];
                actions.push({ label: utils.lng('fechar', 'Fechar'), action: () => {} });
                if (window.dialog) {
                  window.dialog.alert(utils.lng('cliente_ja_esta_na_lista', 'O Cliente selecionado já está na lista. Verifique!'), null, actions);
                }
              } else {
                listaRedeProjetadaClonagem[indiceListaClienteTrocar] = clienteEscolhido;
                switchDialogSelecaoClientes();
              }
              changeIsRedeProjetada();
            }
          }, true);
        },
        function () {
          changeIsRedeProjetada();
        },
      );
    }
  };

  crud.refresh = function () {
    index = index+1;
    setIndex(index);
  }

  const removeClienteDestino = function(index, li) {
    if (li) {
      utils.prompt(
        {
          prompt: utils.lng(
            'deseja_remover_dados_cliente_gerar_cadastro_novo',
            'Deseja remover os dados do Cliente e permitir a geração de um cadastro novo?',
          ),
        },
        function () {
          let clienteOriginal = li.bkpClienteOriginal;
          li.isNovoCadastro = true;
          li.id = null;
          li.idClienteDestino = null;
          li.isVariosClientesDestino = false;
          //
          li.idClienteOriginalCopiar = clienteOriginal ? clienteOriginal.idClienteOriginalCopiar : li.cliente_origem ? li.cliente_origem.id : null;
          li.idClienteOrigem = clienteOriginal ? clienteOriginal.idClienteOriginalCopiar : li.cliente_origem ? li.cliente_origem.id : null;
          li.codigoMundial = clienteOriginal ? clienteOriginal.codigoMundial : li.cliente_origem ? li.cliente_origem.codigoMundial : '';
          li.nome = clienteOriginal ? clienteOriginal.nome : li.cliente_origem ? li.cliente_origem.nome : '';
          li.cliente_origem = clienteOriginal ? clienteOriginal.cliente_origem : null;
          setListaRedeProjetadaClonagem(listaRedeProjetadaClonagem);
          changeIsRedeProjetada();
          crud.refresh();
        },
        function () {
          changeIsRedeProjetada();
        },
      );
    }
  }

  const removePosicaoRede = function(index, obj) {
    if (obj) {
      utils.prompt(
        {
          prompt: utils.lng(
            'deseja_remover_cliente_rede',
            'Deseja remover este Cliente da rede?',
          ),
        },
        function () {
          listaRedeProjetadaClonagem = listaRedeProjetadaClonagem.filter(
            li => li.ordemGeracional !== obj.ordemGeracional
          );
          for (let i=0; i<listaRedeProjetadaClonagem.length; i++) {
            let c = listaRedeProjetadaClonagem[i];
            let posicaoAtual = parseInt(c.ordemGeracional);
            let novaPosicao = parseInt(i);//parseInt(valor.replace(/\D/g, ""), 10);
            if (novaPosicao !== posicaoAtual) {
              c.ordemGeracional = novaPosicao;
              c.descricaoOrdemGeracional = "G"+novaPosicao;
            }
          }
          setListaRedeProjetadaClonagem(listaRedeProjetadaClonagem);
          changeIsRedeProjetada();
        },
        function () {
          changeIsRedeProjetada();
        },
      );
    }
  }

  //

  const listaClientesFilialDestino = {
    elements: {
      content: {
        styleClass: 'ui-lista-clientes',
        elements: {
          lista_clientes_filial_destino: {
            name: 'lista_clientes_filial_destino',
            header: true,
            layout: 'clear',
            add: false,
            type: 'list',
            list: {
              url: 'listar_clientes_por_pais_filial?id_filial_destino='+idFilialDestino
            },
            click: {
              action: 'selecionaCliente'
            },
            columns: {
              codigo: { label: utils.lng("codigo","Código") },
              codigo_referencia: { label: utils.lng("codigo_erp","Código ERP") },
              nome: { label: utils.lng("nome","Nome") }
            }
          }
        }
      }
    }
  };

  const listaDialogClientesFilialDestino = {
    elements: {
      content: {
        styleClass: 'ui-lista-clientes',
        elements: {
          lista_clientes_filial_destino: {
            name: 'lista_clientes_filial_destino',
            header: true,
            layout: 'clear',
            add: false,
            type: 'list',
            data: listaClientesEncontrados,
            //list: {
            //  url: 'listar_clientes_por_pais_filial?id_filial_destino='+idFilialDestino
            //},
            click: {
              action: 'selecionaClientePreCarregado'
            },
            columns: {
              //id: { label: "ID" },
              posicionamento_label: { label: utils.lng('posicionamento','Posicionamento') },
              codigoMundial: { label: utils.lng("codigo_mundial","Cód.Min.") },
              codigoReferencia: { label: utils.lng("codigo_erp","Código ERP") },
              nome: { label: utils.lng("nome","Nome") },
              email: { label: utils.lng("email","E-mail") },
              graduacao: { label: utils.lng("graduacao","Graduação") },
              pai_empresarial: { label: utils.lng("geracao_ascendente","Geração Ascendente") },
              documento: { label: utils.lng("documento","Documento") },
              status_penn: { label: utils.lng("status_penn","Status Penn") },
              status_cliente: { label: utils.lng("status_cliente","Status Cliente") },
              dh_ativacao: { label: utils.lng("data_ativacao","Data Ativação") },
              dh_ultima_compra: { label: utils.lng("data_ultima_compra","Data Última Venda") }
            }
          }
        }
      }
    }
  };

  crud.selecionaClientePreCarregado = function(el, obj) {
    if (obj && obj.data && obj.data.posicionamento !== 'cliente_origem' && clientePosicaoSelecionada) {
      utils.prompt(
        {
          prompt: utils.lng(
            'deseja_selecionar_este_cliente_para_clonagem',
            'Deseja selecionar este Cliente para clonagem?',
          ),
        },
        function () {
          clientePosicaoSelecionada.cliente_destino = obj.data;
          let bkpClienteOriginal = clientePosicaoSelecionada.bkpClienteOriginal;
          if (!bkpClienteOriginal) {
            bkpClienteOriginal = utils.copyObject(clientePosicaoSelecionada);
            clientePosicaoSelecionada.bkpClienteOriginal = bkpClienteOriginal;
          }
          clientePosicaoSelecionada.isNovoCadastro = false;
          clientePosicaoSelecionada.isVariosClientesDestino = false;
          clientePosicaoSelecionada.isClienteDestinoEncontrado = true;
          clientePosicaoSelecionada.id = obj.data.id;
          clientePosicaoSelecionada.idClienteClonar = obj.data.id;
          clientePosicaoSelecionada.idClienteDestino = obj.data.id;
          clientePosicaoSelecionada.codigoMundial = obj.data.codigoMundial;
          clientePosicaoSelecionada.nome = obj.data.nome;
          clientePosicaoSelecionada.status_cliente = obj.data.status_cliente;
          clientePosicaoSelecionada.documento = obj.data.documento;
          clientePosicaoSelecionada.documentoNovoCadastro = obj.data.documento;
          changeIsRedeProjetada();
          switchDialogClientesDestino();
        },
        function () {
          changeIsRedeProjetada();
        },
      );
    }
  }

  const formStart = {
    label: utils.lng('clonagem_cliente_rede', 'Clonagem de Cliente/Rede'),
    name: 'clonagemCliente',
    add: false,
    print: false,
    auto: true,
    type: 'card',
    widgetVar: 'dadosClonagem',
    elements: {
      cliente_copiar: {
        type: 'entity',
        entity: 'Cliente',
        name: 'cliente_copiar',
        field: 'cliente_copiar',
        label: utils.lng('cliente', "Cliente"),
        required: true,
        space: 5,
        disabled: isRedeProjetada,
        data: clienteCopiar,
        change: {
          action: 'onChangeCliente'
        }
      },
      filial_destino: {
        type: 'entity',
        entity: 'Filial',
        name: 'filial_destino',
        field: 'filial_destino',
        label: utils.lng('filial_destino', "Filial de Destino"),
        required: true,
        add: false,
        space: 5,
        size: 50,
        disabled: isRedeProjetada,
        //data: filialDestino,
        change: {
          action: 'onChangeFilial'
        },
        list: {
          url: 'listar_todas_as_filiais_internacional_ativas',
          send: false
        }
      },
      btn_projetar_rede: {
        type: 'button',
        space: 1,
        label: utils.lng('projetar_rede', 'Projetar Rede'),
        disabled: !clienteCopiar || !filialDestino,
        click: {
          action: 'requestProjecaoRede'
        }
      },
      btn_limpar: {
        type: 'button',
        space: 1,
        label: utils.lng('limpar', 'Limpar'),
        click: {
          action: 'limpaTela'
        }
      }
    }
  };

  return (
    <View name="ui-clonagem-cliente">
      <div>
        <div className="ui-col ui-col-12">
          <Element crud={crud} view={view} value={formStart}></Element>
        </div>

        <Dialog
          className="ui-dialog-loading"
          open={loading}>
          <DialogContent>
            <div className="ui-view-loading-data">
              <i className="fas fas fa-circle-notch fa-spin"></i>
            </div>
          </DialogContent>
        </Dialog>

        <Dialog
          className="ui-mmn-dialog"
          open={showDialogSelecaoCliente}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={false}
          maxWidth={false}
          PaperProps={{ style: { width: '60%', height: '60%' } }}
        >
          <DialogContent>
            <Element crud={crud} view={view} value={listaClientesFilialDestino}></Element>
          </DialogContent>
          <DialogActions>
            <Button id="btn_fechar" onClick={switchDialogSelecaoClientes} color="primary">{utils.lng('fechar','Fechar')}</Button>
          </DialogActions>
        </Dialog>

        <Dialog
          className="ui-mmn-dialog"
          open={showDialogClientesDestino}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth={false}
          maxWidth={false}
          PaperProps={{ style: { width: '90%', height: '60%' } }}
        >
          <DialogContent>
            <Element crud={crud} view={view} value={listaDialogClientesFilialDestino}></Element>
          </DialogContent>
          <DialogActions>
            <Button id="btn_fechar" onClick={switchDialogClientesDestino} color="primary">{utils.lng('fechar','Fechar')}</Button>
          </DialogActions>
        </Dialog>
        
        {listaRedeProjetadaClonagem &&
          <>
            <div className="ui-grid-controls-middle">
              {listaRedeProjetadaClonagem.map((li, index) => (
                <div className={"clonagem-cliente-card clonagem-cliente-card-"+(li.isNovoCadastro === true ? "novo" : li.isVariosClientesDestino ? "varios-clientes" : "existente")}>
                  <div className={"clonagem-cliente-card-border clonagem-cliente-card-border-"+(li.isNovoCadastro === true ? "novo" : li.isVariosClientesDestino ? "varios-clientes" : "existente" )}></div>
                  <div className={"clonagem-cliente-card-content clonagem-cliente-card-content-"+(li.isNovoCadastro === true ? "novo" : li.isVariosClientesDestino ? "varios-clientes" : "existente" )}>
                    <FontAwesomeIcon 
                      icon={li.isNovoCadastro === true ? faExclamationTriangle : li.isVariosClientesDestino && !li.isClienteDestinoEncontrado ? faTimes : faCheck} 
                      className={"clonagem-cliente-card-icon-"+(li.isNovoCadastro === true ? "novo" : "existente")} 
                      title={li.isNovoCadastro === true ? utils.lng('novo_cadastro','Novo Cadastro') : utils.lng('cadastro_ja_existente','Cadastro já existente')} 
                    />

                    <div className="clonagem-cliente-card-content-docto">
                      <TextField 
                        variant="outlined" 
                        required={true} 
                        label={utils.lng('documento', 'Documento')}
                        //disabled={!li.isNovoCadastro} 
                        value={li.documentoNovoCadastro ? li.documentoNovoCadastro : ''} 
                        type='text' 
                        inputProps={{ maxLength: 20 }}
                        style={{ background: "white" }}
                        onChange={(e) => {
                          const updatedList = [...listaRedeProjetadaClonagem];
                          updatedList[index].documentoNovoCadastro = e.target.value;
                          setListaRedeProjetadaClonagem(updatedList);
                        }}
                      >
                      </TextField>
                    </div>

                    <div className={"clonagem-cliente-card-text-"+(li.isNovoCadastro === true ? "novo" : li.isVariosClientesDestino ? "varios-clientes" : "existente" )}>
                      
                      <h3>
                        { 
                          '(' + li.descricaoOrdemGeracional + ') ' + 
                          li.codigoMundial + ' - ' + li.nome + 
                          (li.status_cliente ? ' ('+li.status_cliente+')' : '')
                        }
                      </h3>

                      { /* statusInicial: cliente_encontrado | gerar_novo_cliente | varios_clientes_encontrados */ }
                      {li.statusInicial === "cliente_encontrado" &&
                        <i class="fas fa-book fa-2x" 
                          style={{ marginLeft : '20px', cursor : 'pointer' }} 
                          title={utils.lng('abrir_cadastro', 'Abrir Cadastro')}
                          onClick={(e) => {
                            setCacheProjecaoRede();
                            window.location.href = '/crud/Cliente/'+li.id;
                          }}
                        ></i>
                      }

                      { ( li.statusInicial === "gerar_novo_cliente" || li.statusInicial === "varios_clientes_encontrados" ) &&
                        <i class="fas fa-edit fa-2x" 
                          style={{ marginLeft : '20px', cursor : 'pointer' }} 
                          title={utils.lng('mudar_cliente', 'Mudar Cliente')}
                          onClick={(e) => {
                            clientePosicaoSelecionada = li;
                            setClientePosicaoSelecionada(clientePosicaoSelecionada);
                            abreSelecaoCliente(index, li);
                          }}
                        ></i>
                      }

                      {li.statusInicial === "varios_clientes_encontrados" &&
                        <i class="fas fa-search fa-2x" 
                          style={{ marginLeft : '20px', cursor : 'pointer' }} 
                          title={utils.lng('listar_clientes_encontrados','Listar Clientes Encontrados')} 
                          onClick={(e) => {
                            clientePosicaoSelecionada = li;
                            setClientePosicaoSelecionada(clientePosicaoSelecionada);
                            listaClientesEncontrados = [];
                            listaClientesEncontrados.push(li.cliente_origem);
                            listaClientesEncontrados.push(...li.lista_clientes_destino);
                            setListaClientesEncontrados(listaClientesEncontrados);
                            switchDialogClientesDestino();
                          }}
                        ></i>
                      }

                      { ( li.statusInicial === "gerar_novo_cliente" || li.statusInicial === "varios_clientes_encontrados" ) &&
                        <i class="fas fa-plus fa-2x" 
                          style={{ marginLeft : '20px', cursor : 'pointer' }} 
                          title={utils.lng('remove_cliente_destino', 'Remover Cliente de Destino (Gerar Novo Cadastro)')}
                          onClick={(e) => {
                            removeClienteDestino(index, li);
                          }}
                        ></i>
                      }

                      { ( li.statusInicial === "gerar_novo_cliente" || li.statusInicial === "varios_clientes_encontrados" ) &&
                        <i class="fas fa-times fa-2x" 
                          style={{ marginLeft : '20px', cursor : 'pointer' }} 
                          title={utils.lng('remover_posicao_rede', 'Remover Posição da rede')}
                          onClick={(e) => {
                            removePosicaoRede(index, li);
                          }}
                        ></i>
                      }

                    </div>
                    
                  </div>
                </div>
              ))}
            </div>
            
            <div className="ui-col ui-col-12">
              <div className="ui-grid-controls-right ui-grid-controls-middle">
                <Button 
                  onClick={confirmarClonagemRede} 
                  disabled={!isRedeProjetada} 
                  variant="contained" 
                  color="primary" 
                  style={{marginRight: '15px', 
                  height: '45px'}}
                >
                  {utils.lng('confirmar_clonagem_clientes', 'Confirmar Clonagem')}
                </Button>
              </div>
            </div>
          </>
        }
      </div>
    </View>
  )
}
export default ClonagemCliente;